import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import {prop} from "ramda";

const getSpotlightCarouselWidget = () =>
  getWidgetByName("spotlightcarousel")
    .then(Articles)
    .then(prop("articles"))

export { getSpotlightCarouselWidget };
